import { Module } from 'vuex';
import { RootState } from '@/app/app.store';
import {
  InviteValidateStoreState,
  inviteValidateStoreModule,
} from '@/invite/validate/invite-validate.store';
import {
  InviteRegisterStoreState,
  inviteRegisterStoreModule,
} from '@/invite/register/invite-register.store';

export interface InviteStep {
  name: string;
  title: string;
  description: string;
  component: string;
}

export interface InviteStoreState {
  register: InviteRegisterStoreState;
  validate: InviteValidateStoreState;
  name: string;
  currentStepName: string;
  steps: Array<InviteStep>;
}

export const inviteStoreModule: Module<InviteStoreState, RootState> = {
  /**
   * 命名空间
   */
  namespaced: true,

  /**
   * 数据
   */
  state: {
    name: 'inviteStoreModule',
    currentStepName: 'initial',
    steps: [
      {
        name: 'initial',
        title: '邀请',
        description: '请点击验证邀请',
        component: 'ShowcaseHomeHeroContent',
      },
      {
        name: 'validate',
        title: '验证邀请',
        description: '输入邀请码或邀请人',
        component: 'ShowcaseHomeHeroValidate',
      },
      {
        name: 'register',
        title: '注册用户',
        description: '注册新用户',
        component: 'ShowcaseHomeHeroRegister',
      },
      {
        name: 'complete',
        title: '成功了！',
        description: '成功注册了用户',
        component: 'ShowcaseHomeHeroComplete',
      },
      {
        name: 'login',
        title: '用户登录',
        description: '用户登录',
        component: 'ShowcaseHomeHeroLogin',
      },
      {
        name: 'weixinLogin',
        title: '微信登录',
        description: '微信登录',
        component: 'ShowcaseHomeHeroWxLogin',
      },
    ],
  } as InviteStoreState,

  /**
   * 获取器
   */
  getters: {
    currentStepName(state) {
      return state.currentStepName;
    },

    steps(state) {
      return state.steps;
    },

    currentStep(state) {
      return state.steps.find(step => step.name === state.currentStepName);
    },
  },

  /**
   * 修改器
   */
  mutations: {
    setCurrentStepName(state, data) {
      state.currentStepName = data;
    },

    setSteps(state, data) {
      state.steps = data;
    },
  },

  /**
   * 动作
   */
  actions: {
    verifySteps({ state }, stepName: string) {
      return state.steps.some(step => step.name === stepName);
    },
  },

  /**
   * 模块
   */
  modules: {
    register: inviteRegisterStoreModule,
    validate: inviteValidateStoreModule,
  },
};
